module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Foreword")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A little over a decade ago I first met the author while attending a Healer School at Sedona Mago Retreat. After many years and twists and turns of fate the two of us were reunited, again in Sedona, when Marie Anne underwent a personal apprenticeship with me to become a spiritual intuitive reader and guide where I watched her further bloom into the embodiment of all that is goodness and compassion; an embodiment that was so natural to her that it made it clear that she was truly always meant to lead and care for many people who may be struggling here on this Earth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Marie Anne asked me to read her book and write its foreword, I couldn’t wait to see what this intuitive healer with a nursing degree came up with… and again I watched the bloom grow bigger. Written with as much heart as mind, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Taking Back Your Health and Happiness")]), _vm._v(" is an uplifting, informative, and charming read that outlines a truly holistic and compassionate approach to self-care healthcare based upon years of inquiry, experience, and personal implementation. It is with great pride that I have the opportunity to recommend this book to you.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Rebecca Tinkle")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is an award-winning author,")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("American writer, and film producer.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1086bb7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 78
// module chunks = 0